import { ModuleComponent } from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";

export class ModPostList extends ModuleComponent {
    ready() {
        super.ready();

    }
}
